<template>
	<div v-if="tradeHistory.length">
		<div class="accordion" id="trade-history">
			<div class="card shadow-sm mg-b-40">
				<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
					<div>
						<h6 class="mg-b-5">
							<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseTradeHistory" aria-expanded="true" aria-controls="collapseTradeHistory">
								Trade History
							</button>
						</h6>
						<p class="tx-13 tx-color-03 mg-b-0"></p>
					</div>
				</div>
				<div id="collapseTradeHistory" class="collapse show" data-parent="#trade-history">
					<div class="card-body trade-history pd-y-30">
						<div class="table-responsive">
							<table class="table table-dashboard mg-b-0" aria-describedby="trade-history-table">
								<thead>
									<tr>
										<th scope="col">Date</th>
										<th scope="col" class="tx-medium text-center">Order No.</th>
										<th scope="col">Security</th>
										<th scope="col" class="tx-medium text-center">Buy/Sell</th>
										<th scope="col" class="tx-medium text-right">Price</th>
										<th scope="col" class="tx-medium text-right">Quantity</th>
										<th scope="col" class="tx-medium text-right">QTY Executed</th>
										<th scope="col" class="tx-medium text-right">QTY Remaining</th>
										<th scope="col" class="tx-medium text-right">Net Consideration</th>
										<th scope="col" class="tx-medium text-center">Status</th>
										<th scope="col" class="tx-medium text-center"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(trade, index) in tradeHistory" :key="index">
										<td class="tx-color-03 tx-medium">{{ trade.date | toDate('Do MMMM YYYY') }}</td>
										<td class="tx-color-03 tx-medium text-center">{{ trade.order_no | placeholder }}</td>
										<td class="tx-color-03 tx-medium" v-tooltip:top="trade.security">{{ trade.asset.name }}</td>
										<td class="tx-color-03 tx-medium text-center" :class="trade.type">{{ trade.type | toStartCase }}</td>
										<td class="tx-medium text-right">{{ trade.price | toNumber }}</td>
										<td class="tx-medium text-right">{{ trade.units | toNumber }}</td>
										<td class="tx-medium text-right">{{ trade.order_price | toNumber }}</td>
										<td class="tx-medium text-right">{{ (trade.units - trade.quantity_executed) | toNumber }}</td>
										<td class="tx-medium text-right">{{ trade.net_consideration | toNumber }}</td>
										<td class="tx-medium text-center" v-html="transactionStatus(trade.execution_status)"></td>
										<td class="tx-medium text-center">
											<button v-if="trade.can_cancel" type="button" data-toggle="modal" data-target="#cancelTrade" :data-trade="trade.uuid" class="btn btn-white btn-sm shadow-sm">
												Cancel
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<cancel-trade-modal />
	</div>
</template>

<script>
import { requests } from './../../../../../mixins';

export default {
	mixins: [requests.transactions],
	props: {
		tradeHistory: {
			required: true,
			type: Array,
		},
	},
};
</script>

<style>
</style>